import './Page.css';

export default function Services() {
  return (
    <div className="page">
      <h1>Services</h1>
      <div className="services-grid">
        <div className="service-item">
          <h3>Engineering Development Hub Deployment</h3>
          <p>
            Full deployment and customization of the{' '}
            <a href="https://github.com/awslabs/engineering-development-hub" target="_blank" rel="noopener noreferrer">
              AWS Engineering Development Hub (EDH)
            </a>{' '}
            — providing your team with web-based access to HPC clusters, Linux/Windows virtual
            desktops, automated job scheduling, and integrated budget management.
          </p>
        </div>
        <div className="service-item">
          <h3>HPC Cluster Architecture</h3>
          <p>
            Design and deploy scalable compute clusters on AWS using services like
            ParallelCluster, Batch, and EFA-enabled instances for tightly-coupled workloads.
          </p>
        </div>
        <div className="service-item">
          <h3>Workload Migration</h3>
          <p>
            Migrate on-premises HPC workloads to the cloud with minimal disruption,
            including scheduler configuration, storage strategy, and network design.
          </p>
        </div>
        <div className="service-item">
          <h3>Performance & Cost Optimization</h3>
          <p>
            Profile and tune your compute jobs for optimal price-performance using Spot
            instances, right-sized instance families, and intelligent scheduling policies.
          </p>
        </div>
      </div>
    </div>
  );
}
